export const ERROR_TYPES = {
    PERMANENT_CROP_IN_PREVIOUS_YEARS: 'permanent_crop_in_previous_years',
    WRONG_FARM_ADDRESS: 'wrong_farm_address',
} as const;

export type ErrorTypesT = (typeof ERROR_TYPES)[keyof typeof ERROR_TYPES];
